"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("./models/Model"));
exports.Model = Model_1.default;
var Annotation_1 = require("./models/Annotation");
exports.AnnotationModel = Annotation_1.AnnotationModel;
var Appointment_1 = require("./models/Appointment");
exports.AppointmentModel = Appointment_1.AppointmentModel;
var Article_1 = require("./models/Article");
exports.ArticleModel = Article_1.ArticleModel;
var Assertion_1 = require("./models/Assertion");
exports.AssertionModel = Assertion_1.AssertionModel;
var Attendee_1 = require("./models/Attendee");
exports.AttendeeModel = Attendee_1.AttendeeModel;
var Board_1 = require("./models/Board");
exports.BoardModel = Board_1.BoardModel;
var BoardSection_1 = require("./models/BoardSection");
exports.BoardSectionModel = BoardSection_1.BoardSectionModel;
var BoardsClassroom_1 = require("./models/BoardsClassroom");
exports.BoardsClassroomModel = BoardsClassroom_1.BoardsClassroomModel;
var CourseBoards_1 = require("./models/CourseBoards");
exports.CourseBoardsModel = CourseBoards_1.CourseBoardsModel;
var BoardsDegree_1 = require("./models/BoardsDegree");
exports.BoardsDegreeModel = BoardsDegree_1.BoardsDegreeModel;
var BoardsKnowledge_1 = require("./models/BoardsKnowledge");
exports.BoardsKnowledgeModel = BoardsKnowledge_1.BoardsKnowledgeModel;
var BoardsTeacher_1 = require("./models/BoardsTeacher");
exports.BoardsTeacherModel = BoardsTeacher_1.BoardsTeacherModel;
var Campus_1 = require("./models/Campus");
exports.CampusModel = Campus_1.CampusModel;
var City_1 = require("./models/City");
exports.CityModel = City_1.CityModel;
var Channel_1 = require("./models/Channel");
exports.ChannelModel = Channel_1.ChannelModel;
var Classroom_1 = require("./models/Classroom");
exports.ClassroomModel = Classroom_1.ClassroomModel;
var Comment_1 = require("./models/Comment");
exports.CommentModel = Comment_1.CommentModel;
var CommentForum_1 = require("./models/CommentForum");
exports.CommentForumModel = CommentForum_1.CommentForumModel;
var Content_1 = require("./models/Content");
exports.ContentModel = Content_1.ContentModel;
var Pipeline_1 = require("./models/Pipeline");
exports.PipelineModel = Pipeline_1.PipelineModel;
var PipelineRun_1 = require("./models/PipelineRun");
exports.PipelineRunModel = PipelineRun_1.PipelineRunModel;
var Provider_1 = require("./models/Provider");
exports.ProviderModel = Provider_1.ProviderModel;
var ProviderAssociation_1 = require("./models/ProviderAssociation");
exports.ProviderAssociationModel = ProviderAssociation_1.ProviderAssociationModel;
var Contract_1 = require("./models/Contract");
exports.ContractModel = Contract_1.ContractModel;
var Correction_1 = require("./models/Correction");
exports.CorrectionModel = Correction_1.CorrectionModel;
var CorrectionCriteria_1 = require("./models/CorrectionCriteria");
exports.CorrectionCriteriaModel = CorrectionCriteria_1.CorrectionCriteriaModel;
var CorrectionScore_1 = require("./models/CorrectionScore");
exports.CorrectionScoreModel = CorrectionScore_1.CorrectionScoreModel;
var Course_1 = require("./models/Course");
exports.CourseModel = Course_1.CourseModel;
var Degree_1 = require("./models/Degree");
exports.DegreeModel = Degree_1.DegreeModel;
var Enrollment_1 = require("./models/Enrollment");
exports.EnrollmentModel = Enrollment_1.EnrollmentModel;
var EssayReply_1 = require("./models/EssayReply");
exports.EssayReplyModel = EssayReply_1.EssayReplyModel;
var Exam_1 = require("./models/Exam");
exports.ExamModel = Exam_1.ExamModel;
var ExamApplication_1 = require("./models/ExamApplication");
exports.ExamApplicationModel = ExamApplication_1.ExamApplicationModel;
var ExamMode_1 = require("./models/ExamMode");
exports.ExamModeModel = ExamMode_1.ExamModeModel;
var ExamGroup_1 = require("./models/ExamGroup");
exports.ExamGroupModel = ExamGroup_1.ExamGroupModel;
var ExamGroupsExams_1 = require("./models/ExamGroupsExams");
exports.ExamGroupsExamsModel = ExamGroupsExams_1.ExamGroupsExamsModel;
var ExaminationBoard_1 = require("./models/ExaminationBoard");
exports.ExaminationBoardModel = ExaminationBoard_1.ExaminationBoardModel;
var ExamQuestion_1 = require("./models/ExamQuestion");
exports.ExamQuestionModel = ExamQuestion_1.ExamQuestionModel;
var Forum_1 = require("./models/Forum");
exports.ForumModel = Forum_1.ForumModel;
var Image_1 = require("./models/Image");
exports.ImageModel = Image_1.ImageModel;
var Institution_1 = require("./models/Institution");
exports.InstitutionModel = Institution_1.InstitutionModel;
var Knowledge_1 = require("./models/Knowledge");
exports.KnowledgeModel = Knowledge_1.KnowledgeModel;
var KnowledgeAssociation_1 = require("./models/KnowledgeAssociation");
exports.KnowledgeAssociationModel = KnowledgeAssociation_1.KnowledgeAssociationModel;
var List_1 = require("./models/List");
exports.ListModel = List_1.ListModel;
var ListItem_1 = require("./models/ListItem");
exports.ListItemModel = ListItem_1.ListItemModel;
var ListSession_1 = require("./models/ListSession");
exports.ListSessionModel = ListSession_1.ListSessionModel;
var Live_1 = require("./models/Live");
exports.LiveModel = Live_1.LiveModel;
var Material_1 = require("./models/Material");
exports.MaterialModel = Material_1.MaterialModel;
var Offer_1 = require("./models/Offer");
exports.OfferModel = Offer_1.OfferModel;
var Progress_1 = require("./models/Progress");
exports.ProgressModel = Progress_1.ProgressModel;
var QuestionApplication_1 = require("./models/QuestionApplication");
exports.QuestionApplicationModel = QuestionApplication_1.QuestionApplicationModel;
var Question_1 = require("./models/Question");
exports.QuestionModel = Question_1.QuestionModel;
var Reading_1 = require("./models/Reading");
exports.ReadingModel = Reading_1.ReadingModel;
var Reply_1 = require("./models/Reply");
exports.ReplyModel = Reply_1.ReplyModel;
var Role_1 = require("./models/Role");
exports.RoleModel = Role_1.RoleModel;
var School_1 = require("./models/School");
exports.SchoolModel = School_1.SchoolModel;
var Solution_1 = require("./models/Solution");
exports.SolutionModel = Solution_1.SolutionModel;
var Staff_1 = require("./models/Staff");
exports.StaffModel = Staff_1.StaffModel;
var State_1 = require("./models/State");
exports.StateModel = State_1.StateModel;
var Teacher_1 = require("./models/Teacher");
exports.TeacherModel = Teacher_1.TeacherModel;
var Text_1 = require("./models/Text");
exports.TextModel = Text_1.TextModel;
var Topic_1 = require("./models/Topic");
exports.TopicModel = Topic_1.TopicModel;
var UserCampusPreference_1 = require("./models/UserCampusPreference");
exports.UserCampusPreferenceModel = UserCampusPreference_1.UserCampusPreferenceModel;
var User_1 = require("./models/User");
exports.UserModel = User_1.UserModel;
var Video_1 = require("./models/Video");
exports.VideoModel = Video_1.VideoModel;
var Task_1 = require("./models/Task");
exports.TaskModel = Task_1.TaskModel;
var BoardsGroup_1 = require("./models/westeros/boardsgroup/BoardsGroup");
exports.BoardsGroupModel = BoardsGroup_1.BoardsGroupModel;
var Group_1 = require("./models/westeros/boardsgroup/Group");
exports.GroupModel = Group_1.GroupModel;
var ExerciseCommentAttachment_1 = require("./models/ExerciseCommentAttachment");
exports.ExerciseCommentAttachmentModel = ExerciseCommentAttachment_1.ExerciseCommentAttachmentModel;
